import { render, staticRenderFns } from "./Guild.vue?vue&type=template&id=c2498850&"
import script from "./Guild.vue?vue&type=script&lang=js&"
export * from "./Guild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports